import styled from 'styled-components'
interface SignTitleProps {
  children: JSX.Element | JSX.Element[] | string
  style?: React.CSSProperties
  show?: boolean
}
export const SignTitle = (props: SignTitleProps) => {
  const { children, style, show } = props
  return (
    <SignTitleContainer style={style}>
      {show && <div className="icon" />}
      <div className="text" style={style}>
        {children}
      </div>
    </SignTitleContainer>
  )
}

const SignTitleContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  .icon {
    width: 4px;
    height: 18px;
    background-color: #4238c9;
    margin-right: 8px;
    border-radius: 2px;
  }
  .text {
    flex-grow: 1;
    overflow: hidden;
    line-height: 1.2;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
